import { type OperationVariables } from '@apollo/react-common';
import {
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useLazyQuery,
} from '@apollo/react-hooks';

export function useLazyQueryInterop<TData, TVariables = OperationVariables>(
	...args: Parameters<typeof useLazyQuery<TData, TVariables>>
): ReturnType<typeof useLazyQuery<TData, TVariables>> {
	return useLazyQuery<TData, TVariables>(...args);
}
